import campaigns from './campaigns';
import kioskSearch from './kioskSearch';

const menuItems = (campaignItems) => {
  const campaignsList = campaigns(campaignItems);

  return {
    items: [
      {
        id: 'main-menu',
        type: 'group',
        children: [campaignsList, kioskSearch]
      }
    ]
  };
};

export default menuItems;
